<template>
	<UnregisteredPageLayout :message="message">
		<form @submit.prevent="submitEmail" name="inviteForm">
			<input
				v-if="!message"
				type="email"
				id="email"
				v-model="email"
				required
				placeholder="Type email and press Enter"
			/>
			<button type="submit"/>
		</form>
	</UnregisteredPageLayout>
</template>

<script>
import UnregisteredPageLayout from './_PageLayout.vue'

export default {
	name: 'Invite',
	components: {
		UnregisteredPageLayout
	},
	data() {
		return {
			email: '',
			message: ''
		}
	},
	methods: {
		async submitEmail() {
			this.message = 'Requesting invitation...'
			
			try {
				await this.$api.post('/api/invite', {
					email: this.email
				})		  
				this.message = 'Invitation request sent. Please wait for manual approval by an administrator.'
			} catch (error) {
				if (error.response && error.response.status == this.$StatusCodes.CONFLICT) {
					this.message = 'An invitation request has already been sent, but may be not approved yet.'
				} else {
					this.message = 'An error occurred. Please try again.'
				}
				console.error('Error:', error)
			}
		}
	}
}
</script>

<style scoped>
</style>
